import { defineComponent as _defineComponent } from 'vue';
import { createCommentVNode as _createCommentVNode, unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, withCtx as _withCtx, createElementBlock as _createElementBlock } from "vue";
import { UIModal, UIModalContent, UIModalHeader } from '@gohighlevel/ghl-ui';
import VueJsonPretty from 'vue-json-pretty';
import 'vue-json-pretty/lib/styles.css';
export default /*#__PURE__*/ _defineComponent({
    __name: 'FieldDetailsModal',
    props: {
        showModal: Boolean,
        data: String,
        title: String,
        onCancelClick: Function,
    },
    setup(__props) {
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", null, [
                _createVNode(_unref(UIModal), { show: __props.showModal }, {
                    header: _withCtx(() => [
                        _createVNode(_unref(UIModalHeader), {
                            id: "viewDetailsHeader",
                            title: __props.title,
                            onClose: _cache[0] || (_cache[0] = ($event) => (__props.onCancelClick()))
                        }, null, 8 /* PROPS */, ["title"]),
                        _createCommentVNode(" Map the data received to json pretty "),
                        _createVNode(_unref(UIModalContent), null, {
                            default: _withCtx(() => [
                                (__props.data)
                                    ? (_openBlock(), _createBlock(_unref(VueJsonPretty), {
                                        key: 0,
                                        data: __props.data,
                                        deep: 1
                                    }, null, 8 /* PROPS */, ["data"]))
                                    : _createCommentVNode("v-if", true)
                            ]),
                            _: 1 /* STABLE */
                        })
                    ]),
                    _: 1 /* STABLE */
                }, 8 /* PROPS */, ["show"])
            ]));
        };
    }
});
